import axios from 'axios';
import NProgress from 'nprogress';
import router from '@/router';
import 'nprogress/nprogress.css';

NProgress.configure({ showSpinner: false });

const service = axios.create({
  baseURL: process.env.VUE_APP_OPEN,
  withCredentials: true,
});

service.interceptors.request.use((config) => {
  NProgress.start();
  return config;
});

service.interceptors.response.use((response) => {
  NProgress.done();

  const { status, data } = response;

  if (status === 403) {
    router.push('/403');
    return false;
  }

  if (status >= 404 && status < 422) {
    router.push('/404');
    return false;
  }

  if (status <= 504 && status >= 500) {
    router.push('/500');
    return false;
  }

  return data;
}, (error) => {
  // eslint-disable-next-line
  console.log(`接口信息：${error.msg}` || '系统繁忙');
  return Promise.reject(error);
});

export default service;
